module.exports = "<div class=app-error translate>An error occurred, please retry.</div> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/widgets/error/partial.html
// module id = 542
// module chunks = 0